import { useContext } from 'react';
import { mainContext } from '../contexts/mainContext';

function useMainContext() {
	const mainInfo = useContext(mainContext);
	return mainInfo;
}

export default useMainContext;
